import "./PartsInquiry.module.css";
import MainNavigationHeader from "@/reusable_sections/Header";
import ContactInquiryForm from "./sections/ContactInquiryForm";
import AddressMap from "./sections/AddressMap";
import QuickFaqs from "./sections/QuickFaqs";
import CorporateInformationFooter from "@/reusable_sections/Footer";
import ProductInquiry from "./sections/ProductInquiry";
export default function PartsInquiryPage() {
  return <div>
      <MainNavigationHeader />
      <ContactInquiryForm />
      <ProductInquiry />
      <AddressMap />
      <QuickFaqs />
      <CorporateInformationFooter />
    </div>;
}